import { css } from 'styled-components';
export default {
    dmSans: {
        regular: css `
      font-family: 'DmSans', system-ui, sans-serif;
      font-optical-sizing: auto;
      font-style: normal;
      font-weight: 400;
    `,
        medium: css `
      font-family: 'DmSans', system-ui, sans-serif;
      font-optical-sizing: auto;
      font-style: normal;
      font-weight: 500;
    `,
        semiBold: css `
      font-family: 'DmSans', system-ui, sans-serif;
      font-optical-sizing: auto;
      font-style: normal;
      font-weight: 600;
    `,
        bold: css `
      font-family: 'DmSans', system-ui, sans-serif;
      font-optical-sizing: auto;
      font-style: normal;
      font-weight: 700;
    `,
    },
};
